// removed by extract-text-webpack-plugin
module.exports = {"root":"_2Xiyrrc541EOVIAiV6WOLF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/app/layout.scss
// module id = 1528
// module chunks = 0